import React from 'react';
import { charts } from '@ecosystem/newron-design-system';
import { isEqual } from 'lodash';

interface WithLineChartProps {
  data: any;
  fullWidth?: boolean;

  [key: string]: any;
}

export const WithLineChart: React.FC<WithLineChartProps> = React.memo(
  ({ data, fullWidth = false, ...otherProps }) => {
    const { LineChart, ChartScaleType } = charts;

    return (
      <div data-testid="with-line-chart">
        <LineChart
          data={data}
          xKey={'period'}
          yKey={'value'}
          xScaleType={ChartScaleType.Point}
          yScaleType={ChartScaleType.Linear}
          showMarkers
          isRowGridShown
          fillContainer
          margin={{
            top: 20,
            right: 40,
            bottom: 60,
            left: fullWidth ? 100 : 150,
          }}
          {...otherProps}
        />
      </div>
    );
  },
  (prev, next) => {
    return isEqual(prev.data, next.data);
  },
);
